import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { formatImageWebpAuto } from '../../../../../base/publicMethod/index';
import { h5PageCount, wapactPageCount } from '../../../../../utils';
import { formatTime } from '../../utils/formatTime';
import { formatPlayNum } from '../../utils/playNumUnit';
import { formatVideoDuration } from '../../utils/formatVideoDuration';
import { getTopicData, getSurveyInfo, getSlideData } from '../../utils/api';
import imageUrl from '../../utils/imageUrl';
import { getImageUrl } from '../../utils/image';
import { getSession } from '../../../../../base/base/storage';
import Grounds from '../../../../../base/grounds';
import { WxLaunchApp } from '../../../../wxLaunchApp';

const { callApp, getSchemeLink, getWebAppLink } = require('@ifeng-fe/callapp');

// 左文右图
class TitleImg extends PureComponent {
    static propTypes = {
        item: PropTypes.object,
        url: PropTypes.string,
        countMapCache: PropTypes.object,
        videoPlayCache: PropTypes.object,
        isDisplaySource: PropTypes.bool,
        isNewsTime: PropTypes.bool,
        isFormatTime: PropTypes.bool,
        isCount: PropTypes.bool,
        isLazyImage: PropTypes.bool,
        isClickListItem: PropTypes.bool,
        observer: PropTypes.object,
    };

    static defaultProps = {
        isDisplaySource: true,
        isNewsTime: false,
        isFormatTime: false,
        isCount: true,
        isClickListItem: false,
        isLazyImage: true,
    };

    state = {
        topicCount: 0,
        topicUrl: '',
        surveyCount: 0,
        slideNum: 0,
    };

    ref = React.createRef();

    async componentDidMount() {
        const {
            index,
            item,
            item: { type, base62Id, picNum },
            observer,
        } = this.props;
        const url = item['_url'] || item.url;

        this.ref.current.setAttribute('data-index', index);

        observer.observe(this.ref.current);

        if (type === 'theme') {
            try {
                const topicData = await getTopicData(url);

                this.setState({
                    topicCount: topicData.nnum && topicData.nnum.join,
                    topicUrl: topicData.shareurl,
                });
            } catch (e) {
                console.error(e);
            }
        }

        if (type === 'survey') {
            try {
                const surveyData = await getSurveyInfo(url);

                this.setState({
                    surveyCount: surveyData.surveyinfo && surveyData.surveyinfo.pnum,
                });
            } catch (e) {
                console.error(e);
            }
        }

        if (type === 'slide') {
            let slideNum = 0;

            if (picNum) {
                slideNum = picNum;
            } else {
                try {
                    slideNum = await getSlideData(base62Id);
                } catch (e) {
                    console.error(e);
                }
            }

            this.setState({
                slideNum,
            });
        }
    }

    handleClick = (
        url,
        id,
        newstype,
        kind,
        downloads,
        clickCountConfig,
        isSendCount = true,
        isJumpQQlink = false,
        isCallApp = true,
    ) => {
        const doc_type = newstype;
        const aid = id;
        const { item } = this.props;
        const { noPrefixKind = false, isVideoShare } = item;
        const client = isVideoShare ? 'videoApp' : 'newsApp';

        if (isSendCount) {
            this.feedClickCountFn(clickCountConfig);
        }

        if (isJumpQQlink) {
            if (clickCountConfig) {
                clickCountConfig.other.tag = 't9';
                this.feedClickCountFn(clickCountConfig);
            }
        }

        if (isCallApp) {
            callApp({
                client,
                docType: doc_type,
                pid: aid,
                kind,
                download: downloads && downloads.download,
                downloadAd: downloads && downloads.downloadAd,
                noKindFrom: noPrefixKind,
                isCopySchemeUrl: isJumpQQlink,
            });
        }
    };

    handleCallup = (url, id, newstype, kind, downloads = {}, clickCountConfig, wapactCountConfig) => {
        const { isClickListItem, item } = this.props;
        const { secretCallUp, noPrefixKind, isVideoShare } = item;
        const doc_type = newstype;
        const aid = id;
        const client = isVideoShare ? 'videoApp' : 'newsApp';

        if (isClickListItem) {
            this.feedClickCountFn(clickCountConfig);
            callApp({
                client,
                docType: doc_type,
                pid: aid,
                kind,
                download: downloads && downloads.download,
                downloadAd: downloads && downloads.downloadAd,
            });
        }
        if (secretCallUp && !getSession('secretCallSign')) {
            this.feedWapactCountFn(wapactCountConfig);
            callApp({
                client,
                docType: doc_type,
                pid: aid,
                kind,
                isSecretCall: secretCallUp,
                secretGoUrl: url,
                noKindFrom: noPrefixKind,
                download: downloads && downloads.download,
                downloadAd: downloads && downloads.downloadAd,
            });
        }
    };

    feedClickCountFn = (config) => {
        if (window.grounds) return Grounds.jumpInNative(this.props.item);

        if (config) {
            h5PageCount([config]);
        }
    };

    feedWapactCountFn = (config) => {
        if (config) {
            wapactPageCount(config);
        }
    };

    render() {
        const { topicCount, topicUrl, surveyCount, slideNum } = this.state;
        let { url } = this.props;

        url = topicUrl || url;
        if (typeof window === 'object' && window.grounds) url = null;

        const { item, countMapCache, videoPlayCache, isDisplaySource, isCount, isNewsTime, isFormatTime, isLazyImage } =
            this.props;
        let {
            title,
            source,
            id,
            _id,
            base62Id,
            commentUrl,
            guid,
            type,
            newsTime,
            callUp,
            linkMark,
            newstype,
            clickCount,
            wapactCount,
            kind,
            downloads,
            articleTag,
            articleTagColor,
            thumbnail,
            thumbnails,
            duration,
            locationName,
            hotComment,
            isVideoShare,
            wxLaunchSwitch,
            wxLaunchType,
            hasAdIcon,
        } = item;
        const videoplay = videoPlayCache && videoPlayCache[guid];
        const isSource = isDisplaySource && source && source !== '';
        const date = isFormatTime ? formatTime(newsTime) : newsTime;
        const clickCountConfig = clickCount ? clickCount : '';
        const wapactCountConfig = wapactCount ? wapactCount : '';
        let count = 0;

        id = _id || id;
        if (type === 'theme') {
            count = topicCount;
        } else if (type === 'survey') {
            count = surveyCount;
        } else {
            count = (countMapCache && countMapCache[commentUrl]) || 0;
        }

        const props = {};

        let image = thumbnail && thumbnail !== '' ? thumbnail : thumbnails;

        // thumbnails
        if (image && typeof image === 'object' && 'image' in image) {
            image = getImageUrl(image.image[0]);
        }

        const src = formatImageWebpAuto(image, 226, 150);

        if (isLazyImage) {
            props.src = imageUrl.normal;
            props['data-lazy-src'] = src;
        } else {
            props['src'] = src;
        }

        let tagColorStyle = {};

        if (articleTagColor) {
            switch (articleTagColor) {
                case 7:
                    tagColorStyle = { color: '#3091f5' };
                    break;
                case 8:
                    tagColorStyle = { color: '#ff7900' };
                    break;
                case 9:
                    tagColorStyle = { color: '#4bc259' };
                    break;
                case 10:
                    tagColorStyle = { color: '#f54343' };
                    break;
                case 11:
                    tagColorStyle = { color: '#A1A5AC' };
                    break;
            }
        }

        let tag = '';

        if (type === 'topic') {
            tag = <span className={styles.topicLink} />;
        } else if (type === 'theme') {
            tag = <span className={styles.themeLink} />;
        }
        const schemeLink =
            wxLaunchType === 'weapp'
                ? getWebAppLink({
                      docType: newstype || 'doc',
                      pid: id,
                  })
                : getSchemeLink({
                      docType: newstype || 'doc',
                      pid: id,
                      kind,
                  });

        return (
            <div
                onClick={() => {
                    if (callUp === 1) {
                        this.handleClick(url, id, newstype, kind, downloads, clickCountConfig);
                    }
                }}>
                <div
                    className={styles.titleImg}
                    onClick={this.handleCallup.bind(
                        this,
                        url,
                        id,
                        newstype,
                        kind,
                        downloads,
                        clickCountConfig,
                        wapactCountConfig,
                    )}>
                    <div className={styles.link}>
                        {callUp === 1 ? (
                            <a
                                className={styles.title}
                                onClick={this.handleClick.bind(
                                    this,
                                    url,
                                    id,
                                    newstype,
                                    kind,
                                    downloads,
                                    clickCountConfig,
                                )}>
                                {tag}
                                {title}
                            </a>
                        ) : (
                            <a
                                className={styles.title}
                                href={url}
                                onClick={this.feedClickCountFn.bind(this, clickCountConfig)}>
                                {tag}
                                {title}
                            </a>
                        )}
                        <div className={styles.info}>
                            {callUp === 1 ? (
                                <div>
                                    <span
                                        onClick={this.handleClick.bind(
                                            this,
                                            url,
                                            id,
                                            newstype,
                                            kind,
                                            downloads,
                                            clickCountConfig,
                                        )}
                                        className={styles.openApp}>
                                        打开APP阅读
                                    </span>
                                    {linkMark && (
                                        <a onClick={this.feedClickCountFn.bind(this, clickCountConfig)} href={url}>
                                            <span className={styles.wap}>网页阅读</span>
                                        </a>
                                    )}
                                    {locationName && <span className={styles.location}>{locationName}</span>}
                                    <span className={styles.count}>
                                        {count && count !== 0 ? `${formatPlayNum(count)}评` : ''}
                                    </span>
                                </div>
                            ) : (
                                <div>
                                    {hasAdIcon && (
                                        <img
                                            src="https://x0.ifengimg.com/feprod/c/2023_1_17/16_21_21/1.png"
                                            className={styles.picMark}
                                        />
                                    )}
                                    {hotComment && (
                                        <span className={styles.hotComment}>{`${formatPlayNum(count)}`}</span>
                                    )}
                                    {locationName && <span className={styles.location}>{locationName}</span>}
                                    {articleTag && (
                                        <span style={tagColorStyle} className={styles.stickMark}>
                                            {articleTag}
                                        </span>
                                    )}
                                    {isSource && <span className={styles.source}>{source}</span>}
                                    {videoplay && (
                                        <span className={styles.count}>{`${formatPlayNum(videoplay)}次播放`}</span>
                                    )}
                                    {isCount && !hotComment && count !== 0 && (
                                        <span className={styles.count}>{`${formatPlayNum(count)}评`}</span>
                                    )}
                                    {isNewsTime && date && <span className={styles.date}>{date}</span>}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className={styles.imgBox}>
                        {callUp === 1 ? (
                            <a
                                className={styles.img}
                                onClick={this.handleClick.bind(
                                    this,
                                    url,
                                    id,
                                    newstype,
                                    kind,
                                    downloads,
                                    clickCountConfig,
                                )}>
                                <img {...props} ref={this.ref} />
                                {type === 'slide' && slideNum > 0 ? (
                                    <span className={styles.imgIcon}>
                                        <span />
                                        <span>{slideNum}</span>
                                    </span>
                                ) : (
                                    ''
                                )}
                                {type === 'video' || type === 'miniVideo' ? (
                                    <Fragment>
                                        <span className={styles.playIcon} />
                                        {duration && (
                                            <span className={styles.videoIcon}>
                                                <span />
                                                <span>{formatVideoDuration(Number(duration))}</span>
                                            </span>
                                        )}
                                    </Fragment>
                                ) : (
                                    ''
                                )}
                            </a>
                        ) : (
                            <a
                                className={styles.img}
                                href={url}
                                onClick={this.feedClickCountFn.bind(this, clickCountConfig)}>
                                <img {...props} ref={this.ref} />
                                {type === 'slide' && slideNum > 0 ? (
                                    <span className={styles.imgIcon}>
                                        <span />
                                        <span>{slideNum}</span>
                                    </span>
                                ) : (
                                    ''
                                )}
                                {type === 'video' || type === 'miniVideo' ? (
                                    <Fragment>
                                        <span className={styles.playIcon} />
                                        {duration && (
                                            <span className={styles.videoIcon}>
                                                <span />
                                                <span>{formatVideoDuration(Number(duration))}</span>
                                            </span>
                                        )}
                                    </Fragment>
                                ) : (
                                    ''
                                )}
                            </a>
                        )}
                    </div>
                </div>
                {callUp === 1 && !isVideoShare && wxLaunchSwitch && (
                    <WxLaunchApp
                        launchType={wxLaunchType}
                        launchAppClick={this.handleClick.bind(
                            this,
                            url,
                            id,
                            newstype,
                            kind,
                            downloads,
                            clickCountConfig,
                            true,
                            false,
                            false,
                        )}
                        schemeLink={schemeLink}
                        launchAppFail={this.handleClick.bind(
                            this,
                            url,
                            id,
                            newstype,
                            kind,
                            downloads,
                            clickCountConfig,
                            false,
                            true,
                            true,
                        )}
                    />
                )}
            </div>
        );
    }
}

export default TitleImg;
